import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { isTsdDevice } from '../hooks/useTsd';
import useWhatsNew from '../hooks/useWhatsNew';
import { Button } from './ui';
import './WhatsNewModal.css';

/**
 * Окно «Важное обновление» — только для записей уровня «Важное», один раз за сеанс (не при каждом заходе на экран).
 * На терминале склада (ТСД) окна нет: там сканируют, остаётся значок. «Позже» — до следующего входа.
 */
const KEY = 'wn_modal_shown';
const QUIET = ['/whats-new', '/onboarding', '/login', '/setup', '/scan'];

export default function WhatsNewModal() {
  const { user } = useAuth();
  const { major } = useWhatsNew(!!user);
  const loc = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const quiet = QUIET.some((p) => loc.pathname.startsWith(p)) || (isTsdDevice() && !user?.company_id);

  useEffect(() => {
    if (!user || quiet || !major.length || open) return;
    let shown = false;
    try { shown = sessionStorage.getItem(KEY) === '1'; } catch (e) { /* без хранилища — покажем раз */ }
    if (shown) return;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* не страшно */ }
    setOpen(true);
  }, [user, quiet, major.length, open]);

  if (!open || !major.length) return null;
  const close = () => setOpen(false);
  return (
    <div className="wnm-back" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) close(); }}>
      <div className="wnm" role="dialog" aria-modal="true" aria-label="Важное обновление">
        <span className="wnm__chip"><Sparkles size={13} aria-hidden="true" /> Важное обновление</span>
        <h2 className="wnm__title">{major.length === 1 ? major[0].title : `Важных обновлений: ${major.length}`}</h2>
        <ul className="wnm__list">
          {major.slice(0, 4).map((m) => <li key={m.slug}>{major.length > 1 && <b>{m.title}. </b>}{m.summary}</li>)}
        </ul>
        <div className="wnm__actions">
          <Button variant="ghost" onClick={close}>Позже</Button>
          <Button variant="primary" iconRight={ArrowRight} onClick={() => { close(); navigate('/whats-new'); }}>Посмотреть</Button>
        </div>
      </div>
    </div>
  );
}
